import { Stack, Typography } from '@mui/material';
import { OrgType } from 'src/@types/org';
import Label from 'src/components/label';
import { getDataSourceLabel } from 'src/utils/getDataSourceLabel';

function VoterLookupTag({ label, value, org }: { label?: string; value?: string; org?: OrgType }) {
  if (!value) return null;
  if (label && org && label === 'data_source_id') {
    label = getDataSourceLabel(org);
  }

  return (
    <Label key={value} variant="outlined" color="default" sx={{ flexShrink: 0 }}>
      <Stack direction="row" alignItems="center" gap={0.5}>
        {label && (
          <Typography variant="caption" fontWeight={600} color="textSecondary">
            {label.replace(/_/g, ' ') + ':'}
          </Typography>
        )}
        {value}
      </Stack>
    </Label>
  );
}

export default VoterLookupTag;
